import { Link } from "react-router-dom";
import { allCategories } from "@/lib/articles";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-600">按兴趣探索，快速找到想看的内容</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {allCategories.map((category) => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group relative flex items-center gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">
                {category.name}
              </h3>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {category.subcategories.map((sub) => (
                  <span
                    key={sub.id}
                    className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600"
                  >
                    {sub.name}
                  </span>
                ))}
              </div>
            </div>
            <i className="ri-arrow-right-line ml-auto w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}